/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Partner_Org_Contract_PeriodsInputs */



/**
* | output |
* | --- |
* | "{count} billing periods" |
*
* @param {Partner_Org_Contract_PeriodsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_periods = /** @type {((inputs: Partner_Org_Contract_PeriodsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_PeriodsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Abrechnungsperioden`)
	return /** @type {LocalizedString} */ (`${i?.count} billing periods`)
});